import request from "@/utils/request.js";

/**
 * 根据用户主键、证书类型获取用户认证状态1:审核通过 2:审核未通过 3:待审核,4用户没有认证记录
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserAuditPassStatus(params) {
  return request({
    url: "/userService/api/app/userNurseCertificateApp/getUserAuditPassStatus",
    method: "post",
    data: params
  });
}

/**
 * 根据用户主键、证书类型获取用户是否认证通过
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserIsAuditPass(params) {
  return request({
    url: "/userService/api/app/userNurseCertificateApp/getUserIsAuditPass",
    method: "post",
    data: params
  });
}

/**
 * 根据认证主键获取护士认证信息
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserNurseCertificate(params) {
  return request({
    url: "/userService/api/app/userNurseCertificateApp/getUserNurseCertificate",
    method: "post",
    data: params
  });
}

/**
 * 根据用户主键获取认证列表
 * @param params
 * @returns {AxiosPromise}
 */
export function listCertificateByUserNurseId(params) {
  return request({
    url:
      "/userService/api/app/userNurseCertificateApp/listCertificateByUserNurseId",
    method: "post",
    data: params
  });
}

/**
 * 根据用户主键、证书类型获取证书
 * @param params
 * @returns {AxiosPromise}
 */
export function listUserNurseCertificateAll(params) {
  return request({
    url:
      "/userService/api/app/userNurseCertificateApp/listUserNurseCertificateAll",
    method: "post",
    data: params
  });
}

/**
 * 新增护士认证
 * @param params
 * @returns {AxiosPromise}
 */
export function saveUserNurseCertificate(params) {
  return request({
    url:
      "/userService/api/app/userNurseCertificateApp/saveUserNurseCertificate",
    method: "post",
    data: params
  });
}

/**
 * 根据主键获取认证模板
 * @param params
 * @returns {AxiosPromise}
 */
export function getCertificateTemplateById(params) {
  return request({
    url:
      "/userService/api/app/certificateTemplateApp/getCertificateTemplateById",
    method: "post",
    data: params
  });
}

/**
 * 根据类型获取认证模板列表
 * @param params
 * @returns {AxiosPromise}
 */
export function listCertificateTemplate(params) {
  return request({
    url: "/userService/api/app/certificateTemplateApp/listCertificateTemplate",
    method: "post",
    data: params
  });
}
/**
 * 二要素认证
 * @param params
 * @returns {AxiosPromise}
 */
export function saveNurseRealNameCertTwo(params) {
  return request({
    url:
      "/userService/api/app/userNurseCertificateApp/saveNurseRealNameCertTwo",
    method: "post",
    data: params
  });
}
